import { render, staticRenderFns } from "./NotAdmin.vue?vue&type=template&id=210bc7ac&scoped=true"
import script from "./NotAdmin.vue?vue&type=script&lang=js"
export * from "./NotAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210bc7ac",
  null
  
)

export default component.exports